import { LuxAvatar } from '@gemini/fe-ds-core';
import { Modes } from '@utils/enums/Modes.enum';
import {
  HeaderWrapper,
  TitleAndSubtitleContainer,
  TitleWrapper,
  TypographyDesktop,
  TypographyMobile,
} from './PageHeader.styles';
import { useMemo, useState } from 'react';
//LOGOS
// import LogoLC from '@static/LC/logo.svg';
// import LogoTO from '@static/TO/logo.svg';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { useTranslation } from 'react-i18next';
import { IntegrationModes } from '@utils/enums/IntegrationModes.enum';
import { BrandNameList } from '@utils/consts/brandNameList';

export interface HeaderProps {
  practiceName: string;
  mode: Modes;
  logo: string;
  showLogo?: boolean;
  isForTypWidget?: boolean;
}

const PageHeader = ({
  practiceName,
  mode,
  logo,
  showLogo,
  isForTypWidget = false,
}: HeaderProps) => {
  const { t } = useTranslation();
  const brandName = useOnlineBookingStore(state => state.brandName);
  const integrationMode = useOnlineBookingStore(state => state.integrationMode);

  // const BrandLogo = useMemo(() => {
  //   const logos: Record<string, ReactNode> = {
  //     LC: <LogoLC />,
  //     TO: <LogoTO />,
  //   };

  //   return brandName && logos[brandName];
  // }, [brandName]);

  const [onErrorLogo, setOnErrorLogo] = useState<boolean>(false);

  const showFakeRONATitleAndSubtitle = useMemo(() => {
    return (
      !!brandName &&
      !!integrationMode &&
      integrationMode === IntegrationModes.STANDALONE
    );
  }, [brandName, integrationMode]);

  return (
    <HeaderWrapper
      noSignIn={mode === Modes.STANDALONE}
      isForTypWidget={isForTypWidget}
      className="ob-no-print"
      centered={showFakeRONATitleAndSubtitle}
      borderBottom={showFakeRONATitleAndSubtitle}
    >
      <TitleWrapper>
        {showLogo && !onErrorLogo && !brandName && logo && (
          <LuxAvatar src={logo} onError={() => setOnErrorLogo(true)} />
        )}
        {showFakeRONATitleAndSubtitle ? (
          <TitleAndSubtitleContainer>
            <TypographyDesktop variant={'heading3'}>
              {brandName === BrandNameList.LC
                ? t('OEEStandaloneHeader.scheduleExamTitle').toUpperCase()
                : t('OEEStandaloneHeader.scheduleExamTitle')}
            </TypographyDesktop>
            <TypographyDesktop
              variant={'textMedium'}
              fontSize={'1rem'}
              fontWeight={400}
            >
              {t('OEEStandaloneHeader.scheduleExamSubtitle')}
            </TypographyDesktop>
          </TitleAndSubtitleContainer>
        ) : (
          <>
            <TypographyDesktop variant={'heading1'}>
              {practiceName}
            </TypographyDesktop>
            <TypographyMobile variant={'heading2'}>
              {practiceName}
            </TypographyMobile>
          </>
        )}
      </TitleWrapper>
      {/* {mode !== Modes.STANDALONE && (
        <LuxButton variant="ghost" iconStart="UserIcon">
          {t('generalCta.signIn')}
        </LuxButton>
      )} */}
    </HeaderWrapper>
  );
};

export default PageHeader;
